module.exports = __webpack_public_path__ + "static/media/bpmeasurex-charger-4.255f3f96.png";